const __WEBPACK_NAMESPACE_OBJECT__ = window["core-js/modules/es.object.entries.js"];